<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<form [formGroup]="form">
  <mat-dialog-content>
    <div class="flex flex-col items-stretch">
      @if (isEditing) {
      @if (validationMessage$ | async; as validationMessage) {
      <div class="bg-orange-50 border border-orange-200 rounded-md p-3 mb-4">
        <p class="text-orange-800 text-sm">{{ validationMessage }}</p>
      </div>
      }
      }
      <mat-form-field class="w-full" [testId]="testIds.QUOTE_APPROVED_NOTES">
        <mat-label>Notes</mat-label>
        <textarea matInput cdkTextareaAutosize [cdkAutosizeMinRows]="2" formControlName="notes"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close [testId]="testIds.CANCEL_EVENT_DIALOG_BUTTON">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="saveQuoteApproved()"
      [disabled]="form.invalid || !(canEdit$ | async)" [testId]="testIds.SAVE_QUOTE_APPROVED_BUTTON">
      {{ saveButtonText }}
    </button>
  </mat-dialog-actions>
</form>